export const GLAZING_TEMPLATE_DEFAULT_COLOR = '#E9ECEF'
